export const zendeskWidgetConfig = {
  defaultLocale: 'en-US',
  scripts: {
    widget: {
      id: 'custom-widget-js',
      path: '../../../../../../dist/public/zendesk/widget/js/widget.js'
    }
  },
  styles: {
    widget: {
      id: 'custom-widget-css',
      path: '../../../../../../dist/public/zendesk/widget/css/widget.css'
    },
    launcher: {
      height: '60px',
      types: {
        customerCare: {
          id: 'custom-launcher-css',
          path: '../../../../../../dist/public/zendesk/widget/css/customer_care_launcher.css'
        },
        PCA: {
          id: 'custom-launcher-css',
          path: '../../../../../../dist/public/zendesk/widget/css/pca_launcher.css'
        },
        support: {
          id: 'custom-launcher-css',
          path: '../../../../../../dist/public/zendesk/widget/css/support_launcher.css'
        }
      }
    }
  }
};
